import { render } from "./CustomerListPage.vue?vue&type=template&id=7f157674&scoped=true"
import script from "./CustomerListPage.vue?vue&type=script&lang=js"
export * from "./CustomerListPage.vue?vue&type=script&lang=js"

import "./CustomerListPage.vue?vue&type=style&index=0&id=7f157674&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f157674"]])

export default __exports__